export default "__VITE_ASSET__DjA5_37O__"